<template>
  <div :class='$style.container'>
    <table class='table is-striped is-fullwidth'>
      <thead>
        <tr>
          <th ref='preferenceHeader'>Preference</th>
          <th>Host</th>
          <th>Port</th>
          <th>Require TLS</th>
          <th>Uses Credentials</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for='(smarthost, index) in smarthosts'
          :key='smarthost.host + smarthost.port'
          @click='$emit("rowClicked", smarthost, index)'
          :style='canEdit ? "cursor: pointer" : ""'
        >
          <td>{{ smarthost.priority }}</td>
          <td>{{ smarthost.host }}</td>
          <td>{{ smarthost.port }}</td>
          <td>{{ smarthost.requireTLS || 'false' }}</td>
          <td>{{ usesCredentials(smarthost) }}</td>
        </tr>
      </tbody>
    </table>
    <div :class='[$style.preferenceTooltip, { [$style.show]: preferenceHovered }]'>Like MX records, smarthosts with the lowest preference are used first.</div>
  </div>
</template>

<script>
export default {
  name: 'SmarthostList',

  props: {
    smarthosts: {
      type: Array,
      default: () => []
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      preferenceHovered: false
    };
  },

  mounted() {
    this.$refs.preferenceHeader.addEventListener('mouseenter', () => {
      this.preferenceHovered = true;
    });

    this.$refs.preferenceHeader.addEventListener('mouseleave', () => {
      this.preferenceHovered = false;
    });
  },

  methods: {
    usesCredentials(smarthost) {
      return smarthost.username || smarthost.password ? 'Yes' : 'No';
    }
  }
}
</script>

<style lang="scss" module>
.container {
  position: relative;
}

.preferenceTooltip {
  background: #424242;
  border-radius: 4px;
  display: none;
  padding: 8px;
  position: absolute;
  top: -40px;

  &.show {
    display: block;
  }
}
</style>
